import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sanitaria',
  templateUrl: './sanitaria.component.html',
  styleUrls: ['./sanitaria.component.scss']
})
export class SanitariaComponent implements OnInit {

  public section1 = { title: 'Cosa aspetti?', description: "Che siano polizze per la persona, per i veicoli, professionali o di tutela legale, abbiamo individuato soluzioni pensate proprio per le tue necessità. Dai un'occhiata o lasciati consigliare dai nostri esperti!",
                     ctaLink: "/prodotti", ctaText: "Scopri di più", bgUrl: "../assets/work2.jpg" }
                     
  constructor() { }

  ngOnInit() {
  }

}
